import type { IProductEntity } from '../domain/entities/ProductEntity';
import { mapProductDcToEntity } from './mappers/mapProduct';
import { pricingApiService } from './network/PricingApiService';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function memoizeSuccess<T extends (...args: any[]) => Promise<any>>(
  key: string,
  fn: T,
): T {
  if (typeof window === 'undefined') return fn;

  return async function (...args: Parameters<T>): Promise<ReturnType<T>> {
    const sessionKey = `${key}-${JSON.stringify(args)}`;

    const cachedValue = sessionStorage.getItem(sessionKey);

    if (cachedValue) {
      try {
        return JSON.parse(cachedValue);
      } catch {}
    }

    try {
      const result = await fn(...args);
      sessionStorage.setItem(sessionKey, JSON.stringify(result));
      return result;
    } catch (error) {
      // Do not cache rejections
      throw error;
    }
  } as T;
}

export class PricingRepository {
  getProducts = memoizeSuccess(
    'getProducts',
    async (options: {
      ip?: string;
      searchParams?: Record<string, string>;
    }): Promise<IProductEntity[]> => {
      const products = await pricingApiService.getProducts(options);

      return products.map(mapProductDcToEntity);
    },
  );

  isTrialEnabled = memoizeSuccess('isTrialEnabled', (): Promise<boolean> => {
    return pricingApiService.isTrialEnabled();
  });
}
